import { createSelector } from 'reselect';

import { getFilterParamsAdapter, getTimeFilterParams } from '../../api-adapter';

export const user = (store) => store.user;
const filters = (store) => store.apps.analytics.filters;
const owners = (store) => store.apps.analytics.owners;

export const getUserInfo = createSelector([user],
  (userState) => ({
    user: userState,
    username: userState.username,
  }));

export const getOwners = createSelector([
  owners,
  (store, defaultFilters) => defaultFilters,
], (ownersState, defaultFilters = []) => {
  const ownersList = ownersState.get('owners');
  const ownersFilter = Array.isArray(defaultFilters) ? defaultFilters : [defaultFilters];
  return {
    items: ownersList,
    selectedItems: ownersList.filter(({ name }) => ownersFilter.includes(name)),
  };
});

export const getFiltersParams = createSelector([filters], (filtersState) => ({
  ...getFilterParamsAdapter(filtersState.get('filters')),
  ...getTimeFilterParams(filtersState.get('selectedDateFilter')),
}));

export const getMetadataParams = createSelector([
  filters,
  (store, options = {}) => options,
], (filtersState, { value, filterKey }) => ({
  params: {
    ...getFilterParamsAdapter(filtersState.get('filters')),
    ...getTimeFilterParams(filtersState.get('selectedDateFilter')),
    query: value,
    field: filterKey,
  },
}));
